
export { ShoppingBagButton } from "/codebuild/output/src1091960197/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"